/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingFrequencyType } from './TrainingFrequencyType';
import {
    TrainingFrequencyTypeFromJSON,
    TrainingFrequencyTypeFromJSONTyped,
    TrainingFrequencyTypeToJSON,
    TrainingFrequencyTypeToJSONTyped,
} from './TrainingFrequencyType';
import type { TrainingPaymentMode } from './TrainingPaymentMode';
import {
    TrainingPaymentModeFromJSON,
    TrainingPaymentModeFromJSONTyped,
    TrainingPaymentModeToJSON,
    TrainingPaymentModeToJSONTyped,
} from './TrainingPaymentMode';
import type { TrainingType } from './TrainingType';
import {
    TrainingTypeFromJSON,
    TrainingTypeFromJSONTyped,
    TrainingTypeToJSON,
    TrainingTypeToJSONTyped,
} from './TrainingType';

/**
 * 
 * @export
 * @interface Training
 */
export interface Training {
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    description?: string | null;
    /**
     * 
     * @type {TrainingFrequencyType}
     * @memberof Training
     */
    frequencyType?: TrainingFrequencyType;
    /**
     * 
     * @type {TrainingPaymentMode}
     * @memberof Training
     */
    paymentMode?: TrainingPaymentMode;
    /**
     * 
     * @type {TrainingType}
     * @memberof Training
     */
    trainingType?: TrainingType;
    /**
     * 
     * @type {Date}
     * @memberof Training
     */
    seasonStartDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Training
     */
    seasonEndDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    frequencyPattern?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    endTime?: string;
    /**
     * 
     * @type {number}
     * @memberof Training
     */
    trainingFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Training
     */
    assignedPlayerCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Training
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Training
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Training
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Training
     */
    updatedAt?: Date;
}



/**
 * Check if a given object implements the Training interface.
 */
export function instanceOfTraining(value: object): value is Training {
    return true;
}

export function TrainingFromJSON(json: any): Training {
    return TrainingFromJSONTyped(json, false);
}

export function TrainingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Training {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'frequencyType': json['frequencyType'] == null ? undefined : TrainingFrequencyTypeFromJSON(json['frequencyType']),
        'paymentMode': json['paymentMode'] == null ? undefined : TrainingPaymentModeFromJSON(json['paymentMode']),
        'trainingType': json['trainingType'] == null ? undefined : TrainingTypeFromJSON(json['trainingType']),
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : (new Date(json['seasonStartDate'])),
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : (new Date(json['seasonEndDate'])),
        'frequencyPattern': json['frequencyPattern'] == null ? undefined : json['frequencyPattern'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'trainingFee': json['trainingFee'] == null ? undefined : json['trainingFee'],
        'assignedPlayerCount': json['assignedPlayerCount'] == null ? undefined : json['assignedPlayerCount'],
        'active': json['active'] == null ? undefined : json['active'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function TrainingToJSON(json: any): Training {
    return TrainingToJSONTyped(json, false);
}

export function TrainingToJSONTyped(value?: Training | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'frequencyType': TrainingFrequencyTypeToJSON(value['frequencyType']),
        'paymentMode': TrainingPaymentModeToJSON(value['paymentMode']),
        'trainingType': TrainingTypeToJSON(value['trainingType']),
        'seasonStartDate': value['seasonStartDate'] == null ? value['seasonStartDate'] : value['seasonStartDate'].toISOString().substring(0,10),
        'seasonEndDate': value['seasonEndDate'] == null ? value['seasonEndDate'] : value['seasonEndDate'].toISOString().substring(0,10),
        'frequencyPattern': value['frequencyPattern'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'trainingFee': value['trainingFee'],
        'assignedPlayerCount': value['assignedPlayerCount'],
        'active': value['active'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

